export default __webpack_public_path__ + "static/media/(61).a1809aab.jpg";